<!-- eslint-disable vue/multi-word-component-names -->
<script>
const persianNumbers = [
  'الف',
  'ب',
  'پ',
  'ت',
  'ث',
  'ج',
  'چ',
  'ح',
  'خ',
  'د',
  'ذ',
  'ر',
  'ز',
  'س',
  'ش',
  'ص',
  'ض',
  'ع',
  'غ',
  'ف',
  'ق',
  'ک',
  'گ',
  'م',
  'ن',
  'و',
  'ه',
  'ی',
];
export default {
  props: {
    value: null,
    defaultVal: null,
  },

  data() {
    return {
      persianNumbers,
      firstVal: '',
      secondVal: '',
      thirdVal: '',
      lastVal: '',
    };
  },
  methods: {
    validateOnChange: function (val) {
      const key = val.key;
      const keyCode = val.keyCode;

      const allowedKeys = [
        'Backspace', 'Escape', 'ArrowLeft', 'ArrowRight',
        'Delete', 'Tab', 'Home', 'End'
      ];

      const isNumber = keyCode >= 48 && keyCode <= 57;

      if (
        allowedKeys.includes(key) ||
        isNumber
      ) {
        return;
      } else {
        val.preventDefault();
      }
    },
    onChangeField: function (val, length, previousFieldRef, nextFieldRef) {
      if (val?.trim()?.length === length) {
        this.$refs?.[nextFieldRef]?.focus();
        // event.preventDefault();
      } else if (val?.trim()?.length === 0) {
        this.$refs?.[previousFieldRef]?.focus();
      }
    },
    setCurrentValValue: function (firstVal, secondVal, thirdVal, lastVal) {
      this.firstVal = firstVal;
      this.secondVal = secondVal;
      this.thirdVal = thirdVal;
      this.lastVal = lastVal;
    },
    setInitialVal: function () {
      if (this.value?.length === 10) {
        this.setCurrentValValue(
          this.value.slice(5, 8),
          this.value.slice(2, 5),
          this.value.slice(-2),
          this.value.slice(0, 2),
        );
      } else if (this.value?.length === 8) {
        // this.setCurrentValValue(this.value.slice(5, 7),this.value.slice(2, 5),this.value.slice(-2),this.value.slice(0, 2) )
      } else return;
    },
  },
  computed: {
    plateNumber: function () {
      return `${this.firstVal}${this.secondVal}${this.thirdVal}${this.lastVal}`;
    },
  },
  watch: {
    defaultVal: {
      handler(currentVal) {
        if (currentVal?.length && !this.plateNumber) {
          if (currentVal?.length === 10) {
            this.setCurrentValValue(
              currentVal.slice(0, 2),
              currentVal.slice(2, 5),
              currentVal.slice(5, 8),
              currentVal.slice(8, 10),
            );
          } else if (currentVal?.length === 8) {
            this.setCurrentValValue(
              currentVal.slice(0, 2),
              currentVal.slice(2, 5),
              currentVal[5],
              currentVal.slice(6, 8),
            );
          } else return;
        }
      },
      immediate: true,
    },
    plateNumber: function (currentVal) {
      if (currentVal.trim()) this.$emit('input', currentVal.trim());
    },
  },
};
</script>
<template>
  <v-row no-gutters class="currentVal-container">
    <v-col cols="2">
      <v-text-field ref="lastField" dense outlined hide-details maxlength="2" placeholder="45" v-model="lastVal"
        @input="(val) => onChangeField(val, 2, 'thirdField', 'lastField')" @keydown="validateOnChange"></v-text-field>
    </v-col>
    <v-col cols="4">
      <v-autocomplete ref="thirdField" dense hide-details outlined placeholder="الف" :items="persianNumbers"
        @update:search-input="(val) => onChangeField(val, 1, 'secondField', 'lastField')" v-model="thirdVal"
        @input="(val) => onChangeField(val, 1, 'secondField', 'lastField')"></v-autocomplete>
    </v-col>
    <v-col cols="3">
      <v-text-field ref="secondField" dense outlined hide-details maxlength="3" placeholder="345" v-model="secondVal"
        @input="(val) => onChangeField(val, 3, 'firstField', 'thirdField')" @keydown="validateOnChange"></v-text-field>
    </v-col>
    <v-col cols="2">
      <v-text-field ref="firstField" outlined hide-details dense maxlength="2" placeholder="12" v-model="firstVal"
        @input="(val) => onChangeField(val, 2, 'firstField', 'secondField')" @keydown="validateOnChange"></v-text-field>
    </v-col>
  </v-row>
</template>
<style lang="scss">
.currentVal-container {
  flex-direction: row-reverse !important;
  gap: 0.5rem;

  & {
    input {
      text-align: center;
    }
  }
}
</style>
